import { render, staticRenderFns } from "./Dashboardanalytics.vue?vue&type=template&id=77945946&scoped=true"
import script from "./Dashboardanalytics.vue?vue&type=script&lang=js"
export * from "./Dashboardanalytics.vue?vue&type=script&lang=js"
import style0 from "./Dashboardanalytics.vue?vue&type=style&index=0&id=77945946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77945946",
  null
  
)

export default component.exports